import { Button, Col, Input, Row, Table, DatePicker, Skeleton, Empty, Pagination, Form } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { getPreviousUrl } from '../../../../crm/inPatient/service/crmUtils';
import PageHeader from '../../../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE } from '../../../../../shared/constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { setIsTdsEditable, updateInsurerWiseTdsRates } from '../../../../../store/actions/reconciliationAction';
import { RootState } from '../../../../../store';
import { ReconciliationState } from '../../../../../store/models/reconciliationModel';
import { getInsurerWiseTds } from '../../../../../store/actions/reconciliationAction';
import { centeredNotification } from '../../../../../utils/utility';
import moment from 'moment';

const TdsConfigurationPage = ({ match, location: { pathname } }: any): ReactElement => {
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;
  const blankArr = Array(10).fill(0);
   const [pageIndex, setPageIndex] = useState(1);
   const [data, setData] = useState([{'reconciliationTDSConfigurationId': 0,
   'lookUpId': 0,
   'payerId': 0,      // initial data
   'insurerName': '',
   'tdsValue': 0,
   'tdsFromDate': '2023-09-21T12:03:45.125Z',
   'tdsToDate': '2023-09-21T12:03:45.125Z'}]);

  const { isTdsEditable, insurerTdsList, isTableLoading } = useSelector((state: RootState): ReconciliationState =>
  state.reconciliation || []);
  useEffect((): any => {
    dispatch(getInsurerWiseTds());
  }, []);

  const TDS_CONFIGURATOR_COLUMNS = [
    {
      title: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
    },
    {
      title: 'TDS %',
      dataIndex: 'tdsValue',
      key: 'tdsValue',
      render: (text: any, record: any, key: any): any => {
        return isTdsEditable ? (
          <Col md={4}>
            <Form.Item
            >
          <Input
            value={text}
            onChange={(e: any): any => handleInputChange(e, record, 'tdsValue')}
          />
          </Form.Item>
          </Col>
        ) : (
          `${text}%`
        );
      },
    },
    {
      title: 'Date Range for (A) or (B)',
      dataIndex: 'dateRange',
      key: 'dateRange',
      render: (text: any, record: any, key: any): any => {

        return isTdsEditable ? (
          <Col md={12}>
          <RangePicker
            defaultValue={[record.tdsFromDate, record.tdsToDate]}
            onChange={(e: any): any => handleDateChange(e, record)}
          />
          </Col>
        ) : (
          <Col md={12}>
          <RangePicker
            defaultValue={record?.tdsFromDate !== null ?
              [moment(record?.tdsFromDate), moment(record?.tdsToDate)] : [record?.tdsFromDate , record?.tdsToDate]}
            disabled={true}
          />
          </Col>
        );
      },
    },
  ];
  const handleInputChange = (e: any, record: any, dataIndex: any): any => {
    const newData = [...insurerTdsList];
    const targetIndex = newData.findIndex((item: any): any => item.reconciliationTDSConfigurationId === record['reconciliationTDSConfigurationId']);
 // for having a input value check
      if (e.target.value < 1 || e.target.value > 10) {
        centeredNotification('Enter a valid TDS Rate (1-10)', 'error', null, 1);
        newData[targetIndex][dataIndex] = '';
      } else {
        newData[targetIndex][dataIndex] = e?.target?.value;
      }
    setData(newData);

  };

  const handleDateChange = (e: any, record: any): any => {

    const newData = [...insurerTdsList];
    const targetIndex = newData.findIndex((item: any): any => item.reconciliationTDSConfigurationId === record['reconciliationTDSConfigurationId']);
    const tdsfromDate = moment(e[0]);
    newData[targetIndex]['tdsFromDate'] = tdsfromDate;
    const tdstoDate = moment(e[1]);
    newData[targetIndex]['tdsToDate'] = tdstoDate;
    setData(newData);
  };

  const pageChange = (pageNumber: any): any => {
    setPageIndex(pageNumber);
  };
  const onSave = (): any => {  // on click save
    dispatch(setIsTdsEditable(false));
    const payloadData = data.map((d: any): any => {
    if (typeof d.tdsValue === 'string') {
        return {...d, 'tdsValue': parseFloat(d.tdsValue)};
      }
      return d;
    });
   const requestPayload = {'reconciliationTDSConfiguration': payloadData};
    dispatch(updateInsurerWiseTdsRates(requestPayload));
    setTimeout((): any => {
      dispatch(getInsurerWiseTds());
    }, (1000));
  };

  return <React.Fragment>
    <PageHeader pageTitle="Configure Insurer-wise TDS"
      backUrl={getPreviousUrl(pathname)}
      rightComponent={(): ReactElement => <div>
        <Row gutter={GUTTOR_SPACE} justify="end">
          <Col md={2}>
            <Button type={'primary'} disabled={isTdsEditable} onClick={(): any => {
              dispatch(setIsTdsEditable(true));
            }}>
              Edit
            </Button>
          </Col>
          <Col md={4}>
            <Button type={'default'} disabled={!isTdsEditable} onClick={(): any => {
              onSave();
            }}
            >
              Save
            </Button>
          </Col>
        </Row>
      </div>}
    />
  <Col md={24} style={{marginLeft: '20px', marginRight: '20px'}}>
    <Table
      columns={TDS_CONFIGURATOR_COLUMNS}
      dataSource={insurerTdsList}
      pagination={false}
      size={'middle'}
      locale={{
        emptyText: (
          isTableLoading ?
            <div className="full-skelton-in-list">
              {blankArr.map((...params: any[]): any =>
                <Skeleton
                  key={params[1]}
                  active={true}
                  paragraph={{ rows: 0 }}
                />,
              )}
            </div>
            : <Empty />
        ),
      }}
    />
    </Col>
    <Pagination
        data-testid="pagination"
        showSizeChanger={false}
        onChange={pageChange}
        defaultCurrent={1}
        current={pageIndex}
        className="mt-md text-center"
      />
  </React.Fragment>;

};

export default TdsConfigurationPage;
